import React from "react";
import type { PublicCommentConfig } from "./types";
import { useAgendaComments } from "./hooks/useAgendaComments";
import NoticeCard from "./components/NoticeCard";
import PersonalInfoSection from "./components/PersonalInfoSection";
import AgendaCommentsList from "./components/AgendaCommentsList";
import { fieldIdPrefix } from "./utils";
import "./styles/public-comment.css";

interface Props {
  config: PublicCommentConfig;
}

const PublicCommentApp: React.FC<Props> = ({ config }) => {
  const state = useAgendaComments(config);

  return (
    <div className="public-comment-root">
      {config.headerMessage && <NoticeCard message={config.headerMessage} />}

      <PersonalInfoSection
        fields={config.fields}
        formData={state.formData}
        onFieldChange={state.handleFieldChange}
        errors={state.errors}
        idPrefix={fieldIdPrefix(config)}
      />

      <AgendaCommentsList config={config} state={state} />
    </div>
  );
};

export default PublicCommentApp;
